// This makes the js checker shut up about Swiper not being defined
/** @type {*} */
var Swiper;

class FGCarousel extends HTMLElement {
    // This makes the js checker shut up about props in Swiper not existing
    /** @type {*} */
    #swiper = null;
    #config = {
        slidesPerViewDesktop: "auto",
        slidesPerViewMobile: "auto",
        spaceBetweenDesktop: '0',
        spaceBetweenMobile: '0',
        paginationType: 'dots',
        loop: false,
        centeredSlides: false,
        centeredSlidesMobile: false,
        freeMode: false,
        slideEffect: 'none',
        mousewheelEnabled: false,
        autoplayEnabled: false,
        autoplayDelay: 0
    };

    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.dataset.config) {
            console.error('Config not defined');
            return;
        }

        const config = JSON.parse(this.dataset.config);
        this.#config.slidesPerViewDesktop = config.slides_per_view_desktop ?? 'auto';
        this.#config.slidesPerViewMobile = config.slides_per_view_mobile ?? 'auto';
        this.#config.spaceBetweenDesktop = config.space_between_desktop ?? '0';
        this.#config.spaceBetweenMobile = config.space_between_mobile ?? '0';
        this.#config.paginationType = config.pagination_type ?? 'dots';
        this.#config.loop = config.loop ?? false;
        this.#config.centeredSlides = config.centered_slides ?? false;
        this.#config.centeredSlidesMobile = config.centered_slides_mobile ?? config.centered_slides ?? false;
        this.#config.freeMode = config.free_mode ?? false;
        this.#config.slideEffect = config.slide_effect ?? 'none';
        this.#config.mousewheelEnabled = config.mousewheel_nav ?? false;
        this.#config.autoplayEnabled = config.autoplay_enabled ?? false;
        this.#config.autoplayDelay = config.autoplay_delay ?? 0;

        const swiperElement = this.querySelector('.swiper');
        if (this.#config.slideEffect === 'scale_active') {
            swiperElement?.classList.add('effect-scale-active');
        }
        const swiperNavPrevElement = this.querySelector('.swiper-button-prev');
        const swiperNavNextElement = this.querySelector('.swiper-button-next');
        const swiperScrollbarElement = this.querySelector('.swiper-scrollbar');
        const swiperPaginationElement = this.querySelector('.swiper-pagination');

        let paginationSettings = {}
        if (this.#config.paginationType === 'page_number') {
            /**
             * 
             * @param {*} swiper 
             * @param {number} current 
             * @param {number} total 
             * @returns {string} 
             */
            paginationSettings.renderCustom = (swiper, current, total) => {
                return `<span class="current">${current}</span> of <span class="total">${total}</span>`
            };
            paginationSettings.type = 'custom';
        }

        let mousewheelSettings = {}
        if (this.#config.mousewheelEnabled) {
            mousewheelSettings = {
                mousewheel: {
                    releaseOnEdges: true,
                    forceToAxis: true,
                    sensitivity: 0.5,
                    thresholdDelta: 30
                },
            }
        }

        // Maybe disable this in the theme editor by checking Shopify.designMode
        let autoplaySettings = {}
        if (this.#config.autoplayEnabled) {
            autoplaySettings = {
                autoplay: {
                    delay: this.#config.autoplayDelay * 1000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true
                }
            }
        }

        this.#swiper = new Swiper(swiperElement, {
            freeMode: this.#config.freeMode,
            scrollbar: {
                el: swiperScrollbarElement
            },
            pagination: {
                el: swiperPaginationElement,
                /**
                 * 
                 * @param {number} index 
                 * @param {string} className 
                 */
                renderBullet: (index, className) => {
                    return `<span class="fg-swiper-bullet ${className}">
                                <span class="fg-progress">
                                    <svg viewbox="0 0 48 48">
                                        <circle cx="24" cy="24" r="20"></circle>
                                    </svg>
                                </span>
                            </span>`;
                },
                ...paginationSettings
            },
            navigation: {
                prevEl: swiperNavPrevElement,
                nextEl: swiperNavNextElement,
            },
            loop: this.#config.loop,
            centeredSlides: this.#config.centeredSlidesMobile,
            slidesPerView: this.#config.slidesPerViewMobile,
            spaceBetween: this.#config.spaceBetweenMobile,
            breakpoints: {
                750: { // screen greater than 750px
                    slidesPerView: this.#config.slidesPerViewDesktop,
                    spaceBetween: this.#config.spaceBetweenDesktop,
                    centeredSlides: this.#config.centeredSlides
                }
            },
            on: {
                /**
                 * 
                 * @param {*} swiper
                 * @param {number} time 
                 * @param {number} progress 
                 */
                autoplayTimeLeft: (swiper, time, progress) => {
                    if (!swiperPaginationElement) {
                        return;
                    }
                    // @ts-ignore
                    swiperPaginationElement.style.setProperty("--fg-carousel-autoplay-progress", 1 - progress);
                },
                /**
                 * 
                 * @param {*} swiper 
                 */
                autoplayStop: (swiper) => {
                    if (!swiperPaginationElement) {
                        return;
                    }
                    // @ts-ignore
                    swiperPaginationElement.style.setProperty("--fg-carousel-autoplay-progress", 0);
                }
            },
            ...mousewheelSettings,
            ...autoplaySettings
        });

        if (!this.#swiper) {
            console.error('Unknown problem initializing Swiper');
            return;
        }

        if (!this.#swiper.isLocked) {
            this.classList.add('swiper-unlocked');
        }
        this.#swiper.on('lock', () => {
            this.classList.remove('swiper-unlocked');
        });
        this.#swiper.on('unlock', () => {
            this.classList.add('swiper-unlocked');
        })
    }

    update() {
        if (this.#swiper) {
            this.#swiper.update();
        }
    }
}
if (!customElements.get('fg-carousel')) {
    customElements.define('fg-carousel', FGCarousel);
}